whenAvailable('$', function() {
    $(document).ready(function(){
    if ( $('#neue_faq').length > 0 ) {
        var nx_code = 'nx_'+store_code.toLowerCase();
        if ('nx_us' === nx_code) { nx_code = 'nx'; }
        $.get('https://beans.secretlab.co/index.php/api/retrieve_faq/'+nx_code, function (data) {
            $.each(data.faq, function (category, sets) {
                $.each(sets, function (key, row) {
                    // category name replacement to be serachable in keywordQuery()
                    if (category == 'main') {
                        category_filter = 'general';
                    } else if (category == 'orders') {
                        category_filter = 'order';
                    } else {
                        category_filter = category;
                    }
                    content =   '<div class="faq-question-wrapper q-'+ category_filter +'" id="'+key+'_wrapper"><div class="row faq-question collapsed" data-bs-toggle="collapse" href="#' + key + '_ans" role="button" aria-expanded="false" aria-controls="' + key + '_ans>">'+
                                    '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                '</div><div class="collapse" id="' + key + '_ans" data-bs-parent=".faq-wrapper"><div class="pt-2 px-3">'+row.the_answer+'</div></div></div>';
                    $('#'+category+'_content').append(content);
                    if ('1' === row.is_popular_question) {
                        popular_content =   '<div class="faq-question-wrapper faq-popular" id="popular_'+key+'_wrapper"><div class="row faq-question collapsed" data-bs-toggle="collapse" href="#popular_' + key + '_ans" role="button" aria-expanded="false" aria-controls="popular_' + key + '_ans>">'+
                                        '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                    '</div><div class="collapse" id="popular_' + key + '_ans" data-bs-parent=".faq-wrapper"><div class="pt-2 px-3">'+row.the_answer+'</div></div></div>';
                        $('#popular_content').append(popular_content);
                    }
                });
            });
            $('.replace_email').each(function () {
                $(this).html(store_email).attr('href', 'mailto:'+store_email);
            });
            resultCount();
        }, 'json');
    }
    $('#store_code').val(store_code);
    $('#faq_search').on('keypress', function (e) {
        var code = e.keyCode || e.which;
        if (code == 13) {
            trigger_search($(this));

            // to close keyboard on mobile after tap on enter
            if (isMobile) { e.target.blur(); }
        }
    });
    $('.search-input-field .search-icon').on('click', function (e) {
        e.preventDefault();
        trigger_search($('#faq_search'));
    });
    $('.faq-popular').each(function(i){
        var data = $(this).clone();
        $(data).attr('id','faq_popular_'+i);

        new_id = 'faq_popular_' + i + '_ans';
        $(data).find('.faq-question').attr('href', '#' + new_id).attr('aria-controls', new_id);
        $(data).find('.collapse').attr('id', new_id);

        $('#popular_content').append(data);
    });
    $('.faq-selector').click(function(e) {
        e.preventDefault();

        if ($(this).hasClass('faq-selector-query')) {
            if ($(this).attr('data-type') == 'chairs') { $('#faq_search').val('type:chair'); search_faq('type:chair'); }
            else if ($(this).attr('data-type') == 'desks') { $('#faq_search').val('type:desk'); search_faq('type:desk'); }
        } else {
            $('#faq_search').val(''); search_faq('');
        }

        $('html, body').animate({ scrollTop: $($.attr(this, 'href'))?.offset()?.top - $('.nav-main')?.height() }, 500);
    });
    $('#clearSearch').click(function(e) {
        e.preventDefault();
        $('#faq_search').val('');
        search_faq('');
        $('html, body').animate({ scrollTop: 0 }, 500);
    })
    // FUNCTIONS
    function trigger_search($elem) {
        var query = $elem.val().toLowerCase();
        search_faq(query);

        $('html, body').animate({ scrollTop: $('#faq_content').offset().top - $('.nav-main').height() }, 500);
    }
    var queryResult;
    function search_faq(query) {
        if (query == '') {
            $('.faq-container, .faq-question-wrapper').show();
            $('#faq-filtered').hide();
        }

        queryResult = '';
        keywordQuery(query);
        if (queryResult) {
            $('#faq-all .faq-question-wrapper').hide();
            $('#faq-filtered, #faq-all, .faq-container, ' + queryResult).show();
            $('.faq-container').each(function() {
                if(!$(this).find('.faq-question-wrapper').is(':visible')) {
                    $(this).hide();
                }
            });
            if(!$('#faq-all').find('.faq-container').is(':visible')) {
                $('#faq-all').hide();
            }
        } else {
            $('#faq-all, #main, #orders, #shipping, #delivery, #warranty, #assembly, #faq-all .faq-question-wrapper').filter(function() {
                $(this).toggle($(this).text().toLowerCase().indexOf(query) > -1)
            });

            if (query !== '') { $('#faq-filtered').show(); }
        }
        if ( $('#faq-all').is(':hidden') ) { $('#faq_nothing').css('display', 'flex'); } else { $('#faq_nothing').hide(); }
    }
    function keywordQuery(query) {
        var keywords = {
            'q-general': ['about', 'comfort', 'comfortable', 'experience', 'history'],
            'q-product': ['2020', '2022', 'certified', 'difference', 'dimension', 'dimensions', 'feature', 'features', 'guide', 'fit', 'omega', 'model', 'size', 'sizes', 'sizing', 'titan', 'xl', 'small', 'regular', 'evo'],
            'q-features': ['2020', '2022', 'armrest', 'caster', 'castor', 'cloth', 'cold', 'fabric', 'feature', 'features', 'foam', 'height', 'leather', 'multi', 'napa', 'pillow', 'pu', 'softweave', 'tilt', 'upholstery', 'weight', 'wheel', 'wheels', 'neo', 'leatherette', 'magnet', 'magnets'],
            'q-location': ['box', 'boxes', 'location', 'locations', 'pick', 'po', 'showroom', 'store'],
            'q-payment': ['charge', 'charges', 'charged', 'finance', 'financing', 'pay', 'payment', 'paypal', 'amazonpay'],
            'q-instalment': ['instalment', 'installment', 'instalments', 'installments', 'plan', 'plans', 'rely', 'pace', 'affirm', 'zippay', 'paybright', 'paypal', 'atome', 'hoolah', 'shopback', 'paylater'],
            'q-order': ['cancel', 'change', 'confirm', 'confirmation', 'issue', 'order', 'preorder', 'pre-order', 'status'],
            'q-shipping': ['cost', 'custom', 'customs', 'deliver', 'delivery', 'delivered', 'issue', 'number', 'option', 'options', 'ship', 'shipped', 'shipping', 'status', 'time', 'timeslot', 'timeslots', 'track', 'tracking'],
            'q-tax': ['exempt', 'exempted', 'free', 'tax', 'vat'],
            'q-warranty': ['cover', 'claim', 'extend', 'extended', 'redeem', 'register', 'warranty'],
            'q-support': ['contact', 'help', 'issue', 'problem', 'exchange', 'support', 'team'],
            'q-assembly': ['assemble', 'assembly', 'guide', 'how', 'install', 'installation', 'part', 'parts', 'support', 'rabbit', 'task', 'taskrabbit', 'video'],
            'q-aftercare': ['after', 'aftercare', 'care', 'clean', 'cleaner', 'cleaning', 'gap', 'help', 'side', 'sidegap', 'surface'],
            'q-chair': ['type:chair', 'chair'],
            'q-skins': ['type:skins', 'skins'],
            'q-desk': ['type:desk', 'desk', 'table']
        }
        var keys = Object.keys(keywords);
        var queryString = query.split(' ');
        for (var queryWord of queryString) {
            for (var key of keys) {
                if(keywords[key].indexOf(queryWord) !== -1 && (queryResult.indexOf(key) === -1)) {
                    queryResult += ' .' + key + ', ';
                }
            }
        }
        // Remove the ', ' at the end of the string
        queryResult = queryResult.substring(0, queryResult.length - 2);
    }
    function resultCount() {
        $('.selector-count').each(function() {
            var identifier = $(this).data('to-count'),
                count = 0;

            if (identifier.includes('q-')) {
                $(identifier).each(function() {
                    if (!$(this).parents('#popular').length) { count++; }
                });
            } else {
                count = $(identifier).find('.faq-question-wrapper').length;
            }

            $(this).find('span').text(count);
        });
    }
    setTimeout(resultCount, 200);
});
});
